// Item selection mode for the picker

import { useId } from 'react';

export type ItemSelection = 'single' | 'multiple';

export const useComponentId = () => {
  return useId().replaceAll(':', '_');
};
